import { render, staticRenderFns } from "./order-discount-modal-component.vue?vue&type=template&id=a1e1a3b2&scoped=true"
import script from "./order-discount-modal-component.vue?vue&type=script&lang=js"
export * from "./order-discount-modal-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e1a3b2",
  null
  
)

export default component.exports